import { usePostMessageListener } from '@/hooks/usePostMessageListener';
import { getGenetecPostMessage } from '@/utils/helpers';
import { useCallback } from 'react';
import TagManager from 'react-gtm-module';

const postMessageConnection = getGenetecPostMessage({ source: 'genetec', type: 'connection' });

export const usePowerAppsDatalayer = () => {
  const handleDatalayerMessage = useCallback((props: any) => {
    const data = postMessageConnection(props);
    if (!data?.event) return;

    if (/datalayer/.test(data.event)) {
      TagManager.dataLayer({ dataLayer: data.data });
    }
  }, []);

  usePostMessageListener(handleDatalayerMessage);
};
